module.exports = __webpack_public_path__ + "img/cattunnel06.8be9e3e3.jpg";